import React from "react";

import style from "./settings.module.scss";
import { Button } from "../button";
import { translate } from "../../translations/translate";

export const Settings = ({ onClose, resetCount }) => {
  return (
    <div className={style["wrapper"]}>
      <div className={style["card"]}>
        <h1 className={style["title"]}> {translate("options")} </h1>
        <Button label={translate("reset-access")} onClick={resetCount} />
        <div className={style["close-btn"]}>
          <Button label={translate("close")} onClick={onClose} />
        </div>
      </div>
    </div>
  );
};
